import { BasemapOptionEntity } from '@gishub/domain';
import { BasemapDecorator } from './basemap-decorator';
import { IBasemapSourceStrategyConfig } from '../strategies/i-basemap-source-strategy-config';

export class WithSubdomainsDecorator extends BasemapDecorator {
  constructor(strategy: BasemapDecorator | IBasemapSourceStrategyConfig) {
    super(strategy as any);
  }

  override createConfig(option: BasemapOptionEntity): IBasemapSourceStrategyConfig {
    return this.strategy.createConfig(option);
  }
}
